// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarSubMenu_root__kC7Mp"};